import { Typography } from 'antd'
import { IndicationDetail } from 'features/indicationTriage/api/indicationTriageApi'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import React, { FC, ReactNode } from 'react'

import { DAMAGE_MECHANISM_MAPPING } from './damageMechanismMapping'
import { IndicationThicknessHistogram } from './indicationOverview/IndicationThicknessHistogram'

const INDICATION_OVERVIEW_ORDERING_TUPLE_LIST: [
  string,
  (detail?: IndicationDetail) => ReactNode,
][] = [
  ['Total UT Readings', (detail) => detail?.total_ut_readings ?? ''],
  [
    'Damage Mechanism',
    (detail) => {
      const key = detail?.damage_mechanism
      return key && key in DAMAGE_MECHANISM_MAPPING
        ? DAMAGE_MECHANISM_MAPPING[key]
        : 'Unknown'
    },
  ],
  ['Comments', (detail) => detail?.comments ?? ''],
]

interface OverviewConfig {
  show_ref_val_on_histogram: boolean
  /**
   * Hide the report-derived detail block (Total UT Readings / Damage Mechanism /
   * Comments) and its "not available" fallback, leaving just the histogram. Set
   * by libra FFS LTAs, which carry no backend `data.detail`.
   */
  hide_detail?: boolean
  /** Let the thickness histogram fill the card width instead of the 280px default. */
  full_width_histogram?: boolean
}

const { Text } = Typography

export const Title = () => 'Indication Overview'
export const Width = '24rem'
export const CardView: FC<IndicationDetailCardProps<OverviewConfig>> = ({
  config,
}) => {
  const { indication: item } = useIndicationData()
  return (
    <div>
      <Text>Thickness</Text>
      <IndicationThicknessHistogram
        area={item?.selection}
        maxWidth={config?.full_width_histogram ? '100%' : undefined}
        refValue={
          config?.show_ref_val_on_histogram
            ? item?.classificationInfo?.refVal
            : undefined
        }
      />
      {!config?.hide_detail && (
        <>
          <hr />
          {item?.detail ? (
            <div>
              {INDICATION_OVERVIEW_ORDERING_TUPLE_LIST.map(
                ([label, render]) => {
                  return (
                    <div style={{ display: 'flex', width: '100%' }} key={label}>
                      <Text strong style={{ width: '45%' }}>
                        {label}:
                      </Text>

                      <Text>{render(item.detail)}</Text>
                    </div>
                  )
                }
              )}
            </div>
          ) : (
            <div>Detail information is currently not available</div>
          )}
        </>
      )}
    </div>
  )
}
